<template>
  <el-card v-if="emailData" style="padding: 1em">
    <el-menu :default-active="activeName" class="el-menu-demo" mode="horizontal" @select="(key)=>activeName=key">
      <el-menu-item index="status">Email Progress</el-menu-item>
      <el-menu-item index="emails">Emails Send</el-menu-item>
      <el-menu-item index="report">Full Report</el-menu-item>
    </el-menu>
    <el-card v-model="activeName">
      <div ref="toPrint">
        <transition-group name="el-zoom-in-top">
          <h3 label="Full Report" v-if="activeName=='report'" :key="4"
              style="border-bottom: 1px solid grey;padding-bottom: 10px;">
            Fidelity EMAIL report
            <el-button icon="el-icon-printer" @click="printElement($refs.toPrint,'Email Report')"></el-button>
          </h3>
          <el-card label="States" v-if="activeName=='status'||activeName=='report'"
                   style="border-bottom: 1px solid grey;padding-bottom: 10px;" :key="1">
            <div class="headerCells">
              <div :md="5" style="width: 20%">Email</div>
              <div :md="3" style="width: 16%">Last status</div>
              <div :md="4" style="width: 16%">Sent by you</div>
              <div :md="4" style="width: 16%">Emailed delivered</div>
              <div :md="4" style="width: 16%">Emailed opened</div>
              <div :md="4" v-if="activeName=='status'" style="width: 16%">Actions</div>
            </div>
            <template v-for="(emailInfo,idx) in emailsStatus">
              <div :key="idx"
                   class="dataCells"
                   :class="{
              problem:emailInfo.problem?.length,
            }"
              >
                <div :md="5" style="width: 20%">
                  {{ emailInfo.to || emailInfo.properties?.events?.[0].email }}
                </div>
                <div :md="3" style="text-transform: uppercase;width:20%">
                  <el-popover v-if="emailInfo.problem?.length"
                              placement="right"
                              width="400"
                              trigger="click">
                    <el-row shadow="never">
                      <el-col :span="24" v-for="(pro,idx) in emailInfo.problem" :key="idx">
                        {{ pro }}
                      </el-col>
                    </el-row>
                    <el-button slot="reference" type="danger">{{ emailInfo.status }}</el-button>
                  </el-popover>
                  <div v-else>{{ emailInfo.status }}</div>

                </div>
                <div :md="4" style="width: 16%">{{ momentFormat(emailInfo.created_at) }}</div>
                <template v-if="emailInfo.to!='_note_'">
                  <div :md="4" style="width: 16%">{{ emailInfo.sent_at }}</div>
                  <div :md="4" style="width: 16%">{{ emailInfo.read_at }}</div>
                  <div :md="4" style="width: 16%" v-if="activeName=='status'">
                    <el-button @click="resend(emailInfo.id)">Resend</el-button>
                    <el-button @click="remove(emailInfo.id)">Delete</el-button>
                  </div>
                </template>
                <div v-else :md="13" style="border:1px seagreen dashed;width: 48%">{{ emailInfo.body }}</div>
              </div>

            </template>
            <el-card style="padding: 10px;margin: 10px" class="bright" shadow="always" v-if="activeName=='status'">
              <div slot="header" :md="3" ><i>Keep a note</i></div>
              <el-row>

                <el-col :md="6">
                  <el-tooltip
                      placement="top-start"

                      content="If you check this then this email will be considered as success no matter what">
                    <el-checkbox v-model="newEmail.confirm">Confirm notification</el-checkbox>
                  </el-tooltip>
                </el-col>
                <el-col :md="15">
                  <el-input v-model="newEmail.body" placeholder="write something to remeber" clearable></el-input>
                </el-col>
                <el-col :md="3">
                  <sf-button @click="updateEmail(newEmail)" material="done" style="float: right"></sf-button>
                </el-col>

              </el-row>
            </el-card>
          </el-card>
          <el-card label="Emails" name="emails" style="border-bottom: 1px solid grey;padding-bottom: 10px;"
                   v-if="activeName=='emails'||activeName=='report'" :key="2">
            <div style="font-size: 1.2em">
              <small>the email for:</small>
              {{ where }}
            </div>

            <el-row v-html="theEmail" class="printEmail"></el-row>
          </el-card>
          <div label="Full Report" v-if="activeName=='report'" :key="3">
            <h4 class="headerCells">
              Detailed Report from SendGrid.com
            </h4>
            <el-card v-for="emailInfo in emailData" :key="emailInfo.id">

              <div slot="header">sent to:{{ emailInfo.to }} on {{ emailInfo.sent_at }}</div>
              <pre v-html="emailInfo.properties"></pre>
            </el-card>
          </div>
        </transition-group>
      </div>
    </el-card>


  </el-card>
</template>

<script>
import moment from "moment";
import {fetchList} from "~/api/resource";
import {apiDeleteCall, apiPostCall, apiPutCall} from "../../api/laravel";

export default {
  name: "s-email-report",
  data() {
    return {activeName: 'status', newEmail: {confirm: false, body: null, to: '_note_'}}
  },
  props: {
    emailData: {
      type: [],
      default: () => {
      },
    },
  },
  methods: {
    async updateStatus(emailId) {
      await this.emailCall("email/" + emailId)
      // const _token = await this.getApiAuthToken();
      // let responseHook = await fetch(
      //   "https://api.safecontrol.gr/api/email/" + emailId,
      //   {
      //     headers: {
      //       "Content-Type": "application/json;charset=utf-8",
      //       Authorization: Api.token_type + " " + _token,
      //     },
      //   }
      // );
      // try {
      //   const json = await responseHook.json()
      //   _log_("API.resend....", json);
      // } catch(e) {}
    },
    async updateEmail(emailInfo) {
      if (!emailInfo.confirm && !emailInfo.body.trim())
        return
      _log_("emailInfo.resend....", emailInfo);
      await apiPostCall('email-update', {
        id: emailInfo.id,
        status: emailInfo.confirm ? 'open' : null,
        body: emailInfo.body,
        to: emailInfo.to,
        bookings: this.emailData.bookings
      })
      this.$q.notify({
        type: 'positive',
        position: 'top',
        timeout: 3000,
        message: `done`
      })
      this.$emit('done-processing', {event: 'updateEmail', emailInfo})
    },
    async resend(emailId) {
      _log_('resend', emailId)
      await apiPutCall("email/" + emailId)
      this.$q.notify({
        type: 'positive',
        position: 'top',
        message: `done`
      })
      this.$emit('done-processing', {event: 'resent', emailId})
    },
    remove(emailId) {
      this.$confirm("Are you sure you want to mark this email as deleted", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
          .then(async () => {

            await apiDeleteCall("email/" + emailId, 'DELETE')
            this.$q.notify({
              type: 'positive',
              position: 'top',
              timeout: 3000,
              message: `gone`
            })
            this.$emit('done-processing', {event: 'delete', emailId})
          }).catch(e => {

      })
    }
  },
  computed: {
    emailsStatus() {
      if (!this.emailData) return []
      return this.emailData.map((eml) => {
        if (!['success', 'deferred', 'open', 'processed', 'delivered'].includes(
            eml.status?.toLowerCase()
        )) {
          eml.problem = []
          eml.properties?.events.forEach((ev) => {
            _log_('ev eem', ev)
            if (ev.reason) eml.problem.push(ev.reason)
          })
        }
        return eml;
      })

    },
    theEmail() {

      return this.emailData?.[0]?.body || '';
    },
    where() {
      return this.emailData?.[0]?.name || '';
    },
  },
};
</script>
<style>
.dataCells, .headerCells {
  display: flex;
}

.printEmail h4 {
  font-size: 1.2em;
  font-weight: bold;
}

.dataCells div {
  overflow: hidden;
  min-height: 1.2em;
}

.problem {
  color: red;
}

.headerCells div {
  background-color: gainsboro;
  border: 1px white solid;
}

.dataCells div {
  border: 1px gainsboro solid;
}
</style>
